import { Menu } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import Boop from "../utils/Boop";
import Tomato from "../utils/img/Tomatoto.svg";
import CookCookWordmark from "../utils/img/CookCookWordmark.svg";
import ProfileMenu from "./ProfileMenu";
import SearchField from "./SearchField";
import Button from "./atoms/Button";
const Container = styled.div`
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.colorBackground};
  height: 80px;
  padding: 0px 20px 0px 20px;
  align-self: stretch;
  z-index: 1;
`;
const Wrapper = styled.div`
  display: flex;
  flex-flow: row no-wrap;
  justify-content: space-between;
  align-items: center;
  align-content: stretch;
  gap: 24px;
  height: 100%;
  position: relative;
`;
const MenuLogoWrapper = styled.div`
  display: flex;
  flex-flow: row no-wrap;
  justify-content: space-between;
  align-items: center;
  align-content: stretch;
  gap: 12px;
  position: relative;
`;
const Logo = styled.div`
  font-weight: 700;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.colorOnBackground};
`;
const Img = styled.img`
  height: 32px;
`;
const Navbar = ({ menuOpen, setMenuOpen }) => {
  console.log("Navbar.js");
  return (
    <>
      <Container>
        <Wrapper>
          <MenuLogoWrapper>
            <Button
              variant="ghost"
              size="md"
              icon={<Menu />}
              onClick={() => setMenuOpen(!menuOpen)}
            />
            <Link to="/" style={{ textDecoration: "none", order: 2 }}>
              <Logo>
                <Boop
                  children={<Img src={Tomato} />}
                  boopConfig={{ x: 20, y: 20, rotation: 10 }}
                />
                <Img src={CookCookWordmark} alt="CookCook" />
              </Logo>
            </Link>
          </MenuLogoWrapper>
          <SearchField />
          <ProfileMenu />
        </Wrapper>
      </Container>
    </>
  );
};
export default Navbar;
